import React, { useEffect, useLayoutEffect } from 'react'
import Head from 'next/head'
import Cookies from 'js-cookie'
import Layouts from '@/layouts'
import { isServer, getSystemLocale } from '@/utils'
import { COOKIES_MAP, HOME_PATH } from '@/constants'
import config, { unAuthPages, unRedirectWelcomePage, logoPath } from '@/utils/config'
import '@/plugins/svgSprite'
import { ErrorBoundary } from '@/components'
import { isMobilePage } from '@/utils'
import { appWithTranslation, useTranslation } from '@/libs/next-lang'
import nextLangConfig from '../../next-lang.config'

require('@/style/index.less')

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

function CustomApp({
  Component,
  pageProps,
  router,
  isLogin,
  isBindTag,
  redirectWelcome,
  isMobile,
  giveawayChannel,
}: any) {
  const pathname: string = router.pathname

  const { t } = useTranslation(['header'])

  // pu模块的token失效监听事件
  useEffect(() => {
    const fn = () => {
      router.replace(HOME_PATH)
    }
    window.addEventListener('puTokenFaild', fn)

    return () => {
      window.removeEventListener('puTokenFaild', fn)
    }
  }, [])

  // 保持同constructor 效果一样提前赋值
  useEffect(() => {
    // 区分widow还是mac, 影响滚动条
    if (!window.navigator.userAgent.includes('Mac')) {
      document.querySelector('body')?.classList?.add('isWindows')
    }
  }, [])

  useIsomorphicLayoutEffect(() => {
    function redirectFn() {
      const unRedirectLandingPage = config?.unRedirectLandingPage || []
      if (isMobile && !unRedirectLandingPage.includes(pathname) && config.CB_LANDING_PAGE_URL) {
        // 手机访问用户，重定向落地页
        window.location.href = config.CB_LANDING_PAGE_URL || HOME_PATH
        return
      }
      if (isLogin) {
        // 已登录
        if (!isBindTag && !unRedirectWelcomePage.includes(pathname)) {
          // 未在引导页填写信息的用户，需要重定向引导页(含老用户)
          // 非fbe页面 登录后跳转引导页
          router.replace('/welcome')
        }
      } else {
        // 未登录
        if (!unAuthPages?.includes(pathname)) {
          // 访问需要鉴权的页面，需要做重定向处理
          router.replace(HOME_PATH)
        }
      }
    }
    redirectFn()
  }, [isMobile, isLogin, isBindTag, pathname, redirectWelcome])

  return (
    <ErrorBoundary>
      <Head>
        <link rel="icon" href={logoPath} />
        <title>{t('header:t36')}</title>
      </Head>
      <Layouts app={{ giveawayChannel, pageProps }}>
        <Component {...pageProps} router={router} />
      </Layouts>
    </ErrorBoundary>
  )
}

CustomApp.getInitialProps = async ({ ctx }) => {
  let isLogin: boolean = false
  // 引导页是否提交
  let isBindTag: boolean = false
  let isMobile: boolean = false
  let giveawayChannel: string = ''
  let isInnerUser = false
  let headers: any = {}
  let cookies = {}
  if (isServer()) {
    const req = ctx?.req || {}
    cookies = req?.cookies || {}
    headers = req?.headers || {}
    giveawayChannel = cookies[COOKIES_MAP.GIVEAWAY_CHANNEL] || ''
    isLogin = !!cookies[COOKIES_MAP.TOKEN]
    isBindTag = cookies[COOKIES_MAP.USER_FAVORITE] === '1'
    isMobile = isMobilePage(headers['user-agent'] || '')
    isInnerUser = headers['sino-user-origin'] === '1'
  } else {
    isLogin = !!Cookies.get(COOKIES_MAP.TOKEN)
    isBindTag = Cookies.get(COOKIES_MAP.USER_FAVORITE) === '1'
    giveawayChannel = Cookies.get(COOKIES_MAP.GIVEAWAY_CHANNEL) || ''
    cookies = {
      [COOKIES_MAP.LANGUAGE]: getSystemLocale(),
    }
  }

  return {
    isLogin, // 是否登录
    isBindTag, // 是否在引导页进行了绑定
    isMobile,
    isInnerUser, // 是否内部用户
    giveawayChannel, // 落地页过来的标识
  }
}

export default appWithTranslation(CustomApp, nextLangConfig)
